import { CLINIC } from "../data/clinic";
import { useLang } from "../i18n/LanguageContext";
import { Reveal, Eyebrow } from "./Reveal";
import { MapPin, Navigation } from "lucide-react";

export default function Location() {
  const { t } = useLang();
  const loc = t.location;
  const mapEmbed = `https://www.google.com/maps?q=${encodeURIComponent(CLINIC.mapsQuery)}&output=embed`;
  const directions = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(CLINIC.mapsQuery)}`;

  return (
    <section id="location" data-testid="location-section" className="relative bg-brand-bg py-20 md:py-32">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <Reveal>
          <Eyebrow>{loc.eyebrow}</Eyebrow>
          <h2 className="mt-5 max-w-2xl font-display text-4xl font-normal leading-tight tracking-tight text-brand-ink md:text-5xl">
            {loc.heading}
          </h2>
        </Reveal>

        <div className="mt-12 grid gap-6 lg:grid-cols-[1fr_1.4fr]">
          <Reveal className="h-full">
            <div className="flex h-full flex-col justify-between rounded-3xl border border-brand-border bg-brand-surface p-8">
              <div>
                <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-brand-primary/10 text-brand-primary">
                  <MapPin className="h-6 w-6" strokeWidth={1.5} />
                </div>
                <h3 className="mt-5 font-display text-2xl text-brand-ink">{loc.addrTitle}</h3>
                <p className="mt-3 text-base leading-relaxed text-brand-inksoft">{loc.address}</p>
                <p className="mt-4 text-sm text-brand-inksoft">{loc.addrNote}</p>
              </div>
              <div className="mt-8 flex flex-col gap-3 sm:flex-row">
                <a
                  href={directions}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="get-directions-btn"
                  className="inline-flex flex-1 items-center justify-center gap-2 rounded-full bg-brand-primary px-6 py-4 text-sm font-semibold text-white transition-[transform,background-color] duration-300 hover:-translate-y-0.5 hover:bg-brand-primaryHover"
                >
                  <Navigation className="h-5 w-5" strokeWidth={1.75} /> {t.common.getDirections}
                </a>
                <a
                  href={CLINIC.googleBusiness}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="view-on-google-btn"
                  aria-label={`${t.common.viewOnGoogle} — ${CLINIC.name}`}
                  className="inline-flex flex-1 items-center justify-center gap-2 rounded-full border border-brand-primary px-6 py-4 text-sm font-semibold text-brand-primary transition-colors duration-300 hover:bg-brand-primary hover:text-white"
                >
                  <MapPin className="h-5 w-5" strokeWidth={1.75} /> {t.common.viewOnGoogle}
                </a>
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.1} className="h-full">
            <div className="h-full min-h-[360px] overflow-hidden rounded-3xl border border-brand-border shadow-xl shadow-brand-ink/5">
              <iframe
                title="Map to Dr. Vinita's Kesari Dental Clinic, Sector 16-17 Hisar"
                data-testid="google-map"
                src={mapEmbed}
                className="h-full min-h-[360px] w-full border-0"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
              />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
